<InactivityModal />
<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="card bg-light shadow-sm border-0">
        <!-- Header -->
        <div class="card-header bg-light border-0 d-flex justify-content-between align-items-center mt-3">
          <button class="btn btn-primary btn-sm rounded-3 shadow-sm" @click="openCreateModal">
            <i class="bx bx-plus"></i> Create Event
          </button>
        </div>

        <!-- Table -->
        <div class="card-body bg-light">
          <div class="card-body table-responsive">

            <!-- Events Table -->
            <div class="table-scroll mt-3">
              <table class="table align-middle table-striped table-borderless mb-0">
                <thead class="text-uppercase small bg-dark text-white sticky-top text-xxs">
                  <tr>
                    <th class="text-center">#</th>
                    <th>Event</th>
                    <th class="text-center">Event Type</th>
                    <th class="text-center">Event Recurrence</th>
                    <th class="text-center">Event Start Date</th>
                    <th class="text-center">RSVP Start Date</th>
                    <th class="text-center">RSVP End Date</th>
                    <th class="text-center">Event End Date</th>
                    <th class="text-center">Organizer</th>
                    <th class="text-center">Location</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="text-xxs">
                  <tr v-for="(event, index) in events" :key="event.id" class="border-bottom">
                    <!-- Number -->
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <!-- Event Details -->
                    <td>{{ event.event_name }}</td>
                    <td class="text-center"><span class="chip chip-info">{{ event.event_type?.name }}</span></td>
                    <td class="text-center"><span class="chip chip-secondary">{{ event.recurring_pattern?.name }}</span></td>
                    <td class="text-center">{{ event.start_date }}</td>
                    <td class="text-center">{{ event.rsvp_start_date }}</td>
                    <td class="text-center">{{ event.rsvp_end_date }}</td>
                    <td class="text-center">{{ event.end_date }}</td>
                    <td class="text-center">{{ event.organizer }}</td>
                    <td class="text-center">{{ event.location }}</td>
                    <!-- Actions -->
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button class="btn btn-light btn-sm rounded-3 text-success border text-xxs" @click.prevent="edit_event(event)">Edit</button>
                        <button class="btn btn-light btn-sm rounded-3 text-danger border text-xxs" @click.prevent="deleteEvent(event.id)">Delete</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </div>
  </div>

    <div class="modal fade" id="event_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500" id="exampleModalLabel">{{ event_id ? 'Edit Event' : 'Create your event'}}
          </p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form @submit.prevent="event_id ? update_event() : submit_form()">
          <div class="modal-body modal-body-scroll">

            <div class="mb-3">
              <label for="event_name" class="form-label text-xs fw-500">Event Name <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="event_name" placeholder="Enter event name"
                v-model="event_name">
              <p v-if="errors.event_name" class="text-danger text-xs">{{ errors.event_name }}</p>
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
            </div>
            <div class="d-flex flex-row justify-content-between mx-1">
              <div v-if="$route.name !== 'home_filter' && !event_id">
                <label for="portals" class="form-label text-xs fw-500"><span class="text-danger">*</span>Tag a portal :
                </label>
                <select class="text-xs btn-primary fw-500 border-0 rounded-5 btn-sm mb-3 border-end"
                  v-model="selectedPortalId" id="portals">
                  <option value="" selected hidden>
                    * Tag a portal
                  </option>
                  <option v-for="portal in portals" :value="portal.id" :key="portal.id">{{ portal.name }}</option>
                </select>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label text-xs fw-500">Event Type <span class="text-danger">*</span></label>
              <div class="d-flex flex-row align-items-center">
                <div v-for="(type, index) in event_types" :key="index" class="form-check me-3">
                  <input type="radio" class="form-check-input" :value="type" v-model="event_type" :id="`${type}_event`"
                    :name="`event_type`" />
                  <label :for="`${type}_event`" class="form-check-label">{{ type.name }}</label>
                </div>
              </div>
              <p v-if="errors.event_type" class="text-danger text-xs">{{ errors.event_type }}</p>
            </div>

            <div class="d-flex mt-2 mx-1 justify-content-between align-items-start border-bottom">
              <div class="file-upload my-2 me-4 d-flex flex-column align-items-center">
                <label for="fileInput"
                  class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex">
                  <i class='bx bx-image-add file-upload-icon'></i> Add event content
                </label>
                <input type="file" id="fileInput" class="file-input d-none" @change="handleFileUpload" />
                <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ fileName }}
                </div>
                <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>

                <div v-if="imagePreview" class="mt-2">
                  <img :src="imagePreview" alt="Preview" class="img-fluid rounded"
                    style="max-width: 200px; max-height: 200px;" />
                </div>
              </div>
            </div>
            <QuillEditor theme="snow" v-model="event_description" ref="quillEventEditorRef" class="quill-editor"
              placeholder="Enter your description here..." toolbar="full" />
            <div class="row">
              <!-- Event Start Date -->
              <div class="col-md-3 mb-3">
                <label for="start_date" class="form-label text-xs fw-500">Event Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="start_date" v-model="start_date">
                <p v-if="errors.start_date" class="text-danger text-xs">{{ errors.start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="start_time" class="form-label text-xs fw-500">Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="start_time" v-model="start_time">
                <p v-if="errors.start_time" class="text-danger text-xs">{{ errors.start_time }}</p>
              </div>

              <!-- Event End Date -->
              <div class="col-md-3 mb-3">
                <label for="end_date" class="form-label text-xs fw-500">Event End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="end_date" v-model="end_date">
                <p v-if="errors.end_date" class="text-danger text-xs">{{ errors.end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="end_time" class="form-label text-xs fw-500">End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="end_time" v-model="end_time">
                <p v-if="errors.end_time" class="text-danger text-xs">{{ errors.end_time }}</p>
              </div>

              <!-- RSVP Start Date -->
              <div class="col-md-3 mb-3">
                <label for="rsvp_start_date" class="form-label text-xs fw-500">RSVP Start Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="rsvp_start_date"
                  v-model="rsvp_start_date">
                <p v-if="errors.rsvp_start_date" class="text-danger text-xs">{{ errors.rsvp_start_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="rsvp_start_time" class="form-label text-xs fw-500">RSVP Start Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="rsvp_start_time"
                  v-model="rsvp_start_time">
                <p v-if="errors.rsvp_start_time" class="text-danger text-xs">{{ errors.rsvp_start_time }}</p>
              </div>

              <!-- RSVP End Date -->
              <div class="col-md-3 mb-3">
                <label for="rsvp_end_date" class="form-label text-xs fw-500">RSVP End Date <span
                    class="text-danger">*</span></label>
                <input type="date" class="form-control rounded-5 text-xs" id="rsvp_end_date" v-model="rsvp_end_date">
                <p v-if="errors.rsvp_end_date" class="text-danger text-xs">{{ errors.rsvp_end_date }}</p>
              </div>
              <div class="col-md-3 mb-3">
                <label for="rsvp_end_time" class="form-label text-xs fw-500">RSVP End Time <span
                    class="text-danger">*</span></label>
                <input type="time" class="form-control rounded-5 text-xs" id="rsvp_end_time" v-model="rsvp_end_time">
                <p v-if="errors.rsvp_end_time" class="text-danger text-xs">{{ errors.rsvp_end_time }}</p>
              </div>
            </div>

            <div class="mb-3">
              <label for="organizer" class="form-label text-xs fw-500">Organizer <span
                  class="text-danger">*</span></label>
              <input type="text" class="form-control rounded-5 text-xs" id="organizer"
                placeholder="Enter organizer name" v-model="organizer">
              <p v-if="errors.organizer" class="text-danger text-xs">{{ errors.organizer }}</p>
            </div>
            <div v-if="event_type.name === 'online' || event_type.name === 'hybrid'" class="mb-4">
              <label for="event_link" class="form-label text-xs fw-500 d-block">Event Link <span
                  class="text-danger">*</span></label>
              <input id="event_link" type="url" class="form-control rounded-5 text-xs"
                placeholder="Enter event link (e.g., Zoom, Google Meet,Teams)" v-model="event_link" />
              <p v-if="errors.event_link" class="text-danger text-xs">{{ errors.event_link }}</p>
            </div>
            <div v-if="event_type.name !== 'online'" :key="event_type.name" class="mb-4">
              <label for="mapSearchBox" class="form-label text-xs fw-500 d-block">Search for Location</label>
              <input id="mapSearchBox" type="text" class="form-control rounded-5 text-xs"
                placeholder="Search location..." v-model="location" />
              <p v-if="errors.location" class="text-danger text-xs">{{ errors.location }}</p>
            </div>

            <div class="event-extras"v-if="show_add_extras">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <h3 class="text-xs fw-500 mb-0">Event Extra</h3>
                <button type="button" class="btn btn-outline-primary btn-sm rounded-5 text-xs"
                  @click.prevent="addExtra">
                  <i class="bx bx-plus"></i>
                  Add Extra Item
                </button>
              </div>

              <div id="extraItemsList" class="mt-3">
              </div>
            </div>

          </div>

          <div class="container mt-4"  v-if="showExtrasForm && show_add_extras && extraForms.length > 0">
            <div v-for="(extraForm, extraIndex) in extraForms" :key="extraIndex" id="select_extra_container"
              class="border rounded-3 p-3 mt-3 bg-light">

              <input v-model="extraForm.id" type="text"  class="d-none extra_form_id">

              <div class="mb-3">
                <label class="form-label text-xs fw-500">Select Extra:</label>
                <input type="text" class="form-control selectExtra" v-model="extraForm.selectedExtra"
                  placeholder="Enter or select extra" :list="'extrasList-' + extraIndex">
                <datalist :id="'extrasList-' + extraIndex">
                  <option v-for="extra in availableExtras" :key="extra.id" :value="extra.name"></option>
                </datalist>
              </div>

              <div v-for="(item, itemIndex) in extraForm.items" :key="itemIndex + '_extra'"
                class="border rounded-3 p-2 mb-2 bg-white">

                <input v-model="item.id" type="text" class="d-none item_id">

                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Item Name:</label>
                  <input v-model="item.item_name" type="text" class="form-control rounded-5 text-xs item_name"
                    placeholder="Enter item name">
                </div>


                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Description:</label>
                  <textarea v-model="item.item_description" type="text" class="form-control rounded-3 text-xs item_description" rows="2"
                    placeholder="Enter description"></textarea>
                </div>


                <div class="mb-2">
                  <label class="form-label text-xs fw-500">Price:</label>
                  <input v-model="item.item_price" type="number" class="form-control rounded-5 text-xs item_price"
                    placeholder="0.00" step="0.01" min="0">
                </div>


                <button @click.prevent="removeExtraItem(extraIndex, itemIndex)" class="btn btn-danger btn-sm">
                  <i class="bx bx-trash"></i>
                </button>
              </div>


              <button @click.prevent="addExtraItem(extraIndex)" class="btn btn-outline-success btn-sm mt-2">
                + Add Extra Item
              </button>


              <button @click.prevent="removeExtra(extraIndex)" class="btn btn-danger btn-sm mt-2">
                Remove Extra
              </button>

            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-sm btn-primary text-xxs rounded-3">{{ event_id ? 'Update' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>